import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';

export const isAggregatedFieldMultiple = (field) => (
  field?.state === AGGREGATED_FIELD_STATE.MULTIPLE
);

export const hasAggregatedMultipleFields = (fields = []) => (
  fields.some((field) => isAggregatedFieldMultiple(field))
);

export const getAggregatedCommonString = (field, defaultValue = '') => {
  if (field?.state === AGGREGATED_FIELD_STATE.COMMON) {
    if (field.value == null) return defaultValue;
    return String(field.value);
  }
  return defaultValue;
};

export const getAggregatedCommonBoolean = (field, defaultValue = false) => {
  if (field?.state === AGGREGATED_FIELD_STATE.COMMON) {
    return Boolean(field.value);
  }
  return defaultValue;
};

export const getAggregatedCommonNumber = (field, defaultValue = 0) => {
  if (field?.state === AGGREGATED_FIELD_STATE.COMMON) {
    const { value } = field;
    if (value === '' || value == null) return defaultValue;
    return Number(value);
  }
  return defaultValue;
};

export const isAggregatedIdentityFieldEditable = (field) => {
  if (!field) return false;
  if (field.state === AGGREGATED_FIELD_STATE.NOT_APPLICABLE) return false;
  if (field.state === AGGREGATED_FIELD_STATE.MULTIPLE) return false;
  return field.stats?.applicableCount === 1;
};
